module.exports = __webpack_public_path__ + "img/eg.egde66162.svg";